import { generateTestId } from "@client-shared";

const TEST_ID_PREFIX = "ConnectServiceStep";

/**
 * Static test IDs for ConnectServiceStep component.
 * Use these constants directly for non-iterated elements.
 */
export const CONNECT_SERVICE_STEP_TEST_IDS = {
  container: generateTestId(TEST_ID_PREFIX, "container"),
  title: generateTestId(TEST_ID_PREFIX, "title"),
  description: generateTestId(TEST_ID_PREFIX, "description"),
} as const;
